<template>
	<div>
		<erji-title :titleName="this.titleName" :fatherName="this.fatherName"></erji-title>
		<div class="erji-content">
			<div class="organ">
				<div class="organ1">
					<div class="organ-item" v-if="this.organList[0]" @click="goOrganDetial(organID[0])">
						<div class="organ-pic">
							<div class="imgbox_a">
								<img :src="icoURL+'storage/'+this.organList[0].image" alt="">
							</div>
						</div>
						<div class="organ-title">
							<h1>{{this.organList[0].title}}</h1>
							<h2>{{this.organList[0].sub_title}}</h2>
						</div>
					</div>
				</div>
				<div class="organ2">
					<div class="organ-item" v-if="this.organList[1]" @click="goOrganDetial(organID[1])">
						<div class="organ-pic">
							<div class="imgbox_a"><img :src="icoURL+'storage/'+this.organList[1].image" alt=""></div>
						</div>
						<div class="organ-title">
							<h1>{{this.organList[1].title}}</h1>
							<h2>{{this.organList[1].sub_title}}</h2>
						</div>
					</div>
					
				</div>
				<div class="organ2">
					<div class="organ-item" v-if="this.organList[2]" @click="goOrganDetial(organID[2])">
						<div class="organ-pic">
							<div class="imgbox_a"><img :src="icoURL+'storage/'+this.organList[2].image" alt=""></div>
						</div>
						<div class="organ-title">
							<h1>{{this.organList[2].title}}</h1>
							<h2>{{this.organList[2].sub_title}}</h2>
						</div>
					</div>
					<div class="organ-item" v-if="this.organList[3]" @click="goOrganDetial(organID[3])">
						<div class="organ-pic">
							<div class="imgbox_a"><img :src="icoURL+'storage/'+this.organList[3].image" alt=""></div>
						</div>
						<div class="organ-title">
							<h1>{{this.organList[3].title}}</h1>
							<h2>{{this.organList[3].sub_title}}</h2>
						</div>
					</div>
					<div class="organ-item" v-if="this.organList[4]" @click="goOrganDetial(organID[4])">
						<div class="organ-pic">
							<div class="imgbox_a"><img :src="icoURL+'storage/'+this.organList[4].image" alt=""></div>
						</div>
						<div class="organ-title">
							<h1>{{this.organList[4].title}}</h1>
							<h2>{{this.organList[4].sub_title}}</h2>
						</div>
					</div>
					<div class="organ-item" v-if="this.organList[5]" @click="goOrganDetial(organID[5])">
						<div class="organ-pic">
							<div class="imgbox_a"><img :src="icoURL+'storage/'+this.organList[5].image" alt=""></div>
						</div>
						<div class="organ-title">
							<h1>{{this.organList[5].title}}</h1>
							<h2>{{this.organList[5].sub_title}}</h2>
						</div>
					</div>
				</div>
			</div>
		</div>
	</div>
</template>

<script>
	export default {
	  name: 'organ',
		data(){
			return{
				titleName:'',
				fatherName:'',
				childId:'',
				organList:[],
				organID:[]
			}
		},
		methods:{
			res_menusClass(e){
				this.axios.get('/api/menus/class?id='+e)
					.then(response => {
						// 处理成功情况
						if(response.data.code == 200){
							this.titleName = response.data.reslut.name;
						}
					})
					.catch(error => {
						// 处理错误情况
						console.log(error);
					})
			},
			//请求父类信息
			res_fatherClass(e){
				this.axios.get('/api/menus/class?id='+e)
					.then(response => {
						// 处理成功情况
						if(response.data.code == 200){
							// console.log('response090',response)
								this.fatherName = response.data.reslut.name;
						}
					})
					.catch(error => {
						// 处理错误情况
						console.log(error);
					})
			},
			//领导列表
			res_newsList(){
				this.axios.get("/api/news/listNews?category_id="+this.childId)
					.then(response => {
						// 处理成功情况
						if(response.data.code == 200){
							// this.list = response.data.reslut;
							console.log('responseld',response);
							this.organList = response.data.reslut;
							for(let i = 0 ; i < this.organList.length ; i++){
								this.organID.push(this.organList[i].id);
							}
							
						}
					})
					.catch(error => {
						// 处理错误情况
						console.log(error);
					})
			},
			//领导详情
			goOrganDetial(e){
				// console.log('e',e,this.$route);
				this.$router.push({
					path:'/slider/'+this.$route.params.id+'/detail',
					query:{
						category_id:this.$route.query.category_id,
						id:e
					}
				})
			}
		},
		created() {
			this.childId = this.$route.query.category_id;
			this.res_menusClass(this.childId);
			this.res_fatherClass(this.$route.params.id)
			this.res_newsList()
		},
		mounted(){
		}
	}
</script>

<style>
</style>